// Unified asset-status vocabulary (Draft / Processing / Ready / Error) shared
// across the platform's status chips. Deterministic mirror of the backend's
// asset-status mapper; PROCESSED is terminal-success → Ready.
const ASSET_STATUS_MAP: Record<string, string> = {
  DRAFT: 'DRAFT',
  PROCESSING: 'PROCESSING',
  PROCESSED: 'READY',
  ERROR: 'ERROR',
};

/** Map a raw lifecycle status to the unified asset-status vocabulary. */
export const toAssetStatus = (status: string): string =>
  status ? ASSET_STATUS_MAP[status.toUpperCase()] ?? status : status;
